import React from "react";
import MultipleValueTextInput from "react-multivalue-text-input";

const GroupMultiInput = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-group",
    labelClass = "",
    values=[],
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={divClass}>
        <MultipleValueTextInput values={values} name={name} id={props?.id ?? name} charCodes={[13, 32]} {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupMultiInput;
